let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1wh3V")).then(() => parcelRequire('luDIJ'));